import React, { Fragment, useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { EntryContext } from '../contexts/entryContext';

import TeleScript from '../utils/TeleScript';
import DisplayContent from '../utils/DisplayContent';
import InnerLayout from '../components/layouts/InnerLayout';
import BackButton from '../components/BackButton';

const InformationPage = () => {
    const page = 'information';
    const { game, siteAssets } = useContext(EntryContext);

    // Redirect to home page when the feature is disabled
    const navigate = useNavigate();
    useEffect(() => {
        if (!siteAssets?.features?.moreInfoPageEnabled) {
            return navigate(`/games`, { replace: true });
        }
    }, [siteAssets?.features?.moreInfoPageEnabled, navigate]);

    return (
        <Fragment>
            <InnerLayout logo={true} pageClass={`page-${page}`}>
                <Helmet>
                    <title>
                        {siteAssets?.moreInfoPageTitle ?? 'More Info'} - {siteAssets?.title ?? 'Scratch Connect'}
                    </title>
                </Helmet>

                <DisplayContent note='More Info Header Image' isVisible={siteAssets?.moreInformationHeaderImage?.ref}>
                    <div id='information-header-img' className='information-header-img'>
                        <img src={siteAssets?.moreInformationHeaderImage?.ref} alt={siteAssets?.moreInformationHeaderImage?.alt} />
                    </div>
                </DisplayContent>

                <div className='information'>
                    <div id='information-text' className='info-text'>
                        <TeleScript line={game?.moreInfo}>More Info content</TeleScript>
                    </div>
                </div>
            </InnerLayout>
            <footer>
                <BackButton linkTo={`/games`} />
            </footer>
        </Fragment>
    );
};

export default InformationPage;
